import React, { useState, useEffect, useContext } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css"; 
import { getFamilySummary } from "../../config/apiConfig";
import { sbaAxios } from "../utils/sbaAxios";
import CloseSVG from "../../Images/close_svg.svg"
import { WidgetCollectionContext } from "./home";

const divideValue = (value, divisor) => {
  return value / divisor;
};

const percentCellRenderer = (props) => {
  return (
    <span>
      {divideValue(props.value, 100).toLocaleString(undefined, {
        style: "percent",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
    </span>
  );
};
const FamilyGrid = ({ data }) => {
  const [familySummary, setFamilySummary] = useState([]);
  const [familySelectedButton, setFamilyButton] = useState(0);
  const { removeWidget, toCustomize } = useContext(WidgetCollectionContext);

  useEffect(()=>{
    fetchFamilySummary(false);
  },[]);
  const columnDefs = [
    {
      headerName: "Family", 
      field: "FamilyName", 
      sortable: true, 
      filter: true 
    },
    {
      headerName: "Market Value", 
      field: "MarketValue", 
      sortable: true, 
      filter: true,
      valueFormatter: (params) => `$${params.value.toLocaleString()}`,
    },
    {
      headerName: "MTD%", 
      field: "mtd", 
      cellRenderer: percentCellRenderer,
    },
    {
      headerName: "YTD%", 
      field: "ytd", 
      cellRenderer: percentCellRenderer,
    }
  ];

  const defaultColDef = {
    flex: 1,
    resizable: true,
  };
  const FamilyButtonClick = (index) => {
    setFamilyButton(index);
    fetchFamilySummary(index==1);
  };
  const fetchFamilySummary = async (isAdvised) => {
    try {
      const list = await sbaAxios({
        url: getFamilySummary,
        params: {
          advised: isAdvised
        }
      });
      setFamilySummary(list);
    }
    catch (e) {
      setFamilySummary([]);
    }
  };
  const FamilyButtonNames = ['All Assets', 'Advised'];
  return ( <>
        <div className="k-tilelayout-item k-card k-cursor-grab h-100">

    
    <>
    <div className="k-tilelayout-item-header k-card-header">
    <div className="header-container">
    <b> Families </b>
    <div className="button-container ms-auto">
          {FamilyButtonNames.map((name, index) => (
            <button
              key={index}
              className={familySelectedButton === index ? "selected-non-gappable-button p-2" : "non-gappable-button p-2"}
               onClick={() => FamilyButtonClick(index)}
              >
              {name}
            </button>
          ))}
    </div>
    {toCustomize && <a className="" href="#" onClick={() => {
          removeWidget(1)
        }}>
          <img src={CloseSVG}
            alt="close" />
    </a>}
    </div>
        
    </div>
    </>
  <div className="k-tilelayout-item-body k-card-body">

      <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>
      <AgGridReact
        rowData={familySummary}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        domLayout="autoHeight"
      />
    </div>
  </div>
  </div>
  </>
    
  );
};

export default FamilyGrid;
